// @flow
import * as _ from 'underscore';
import React, { Component } from 'react';

import DesignerBase from './designer-base/DesignerBase';

import Console from '../../lib/debug';

import { getState } from '../../state/store';

import * as CalendarState from '../../state/reducer/calendar/calendar';
import * as DesignerState from '../../state/reducer/designer/designer';
import * as AppState from '../../state/reducer/app/appState';
import * as ProgramTypes from '../../state/reducer/calendar/programTypes';

type Props = {
    match: {
        params: {
            programId: string | number,
            year: string | number,
            month: string | number,
            day: string | number
        }
    }
};

export default class TeamDesignerView extends Component<Props> {
    constructor(props: Props) {
        super(props);
        this.loadCalendarData();
    }

    componentDidUpdate() {
        this.loadCalendarData();
    }

    async loadCalendarData() {
        const programId = parseInt(this.props.match.params.programId);
        const year = parseInt(this.props.match.params.year);
        const month = parseInt(this.props.match.params.month);
        const day = parseInt(this.props.match.params.day);

        const dayKey = `${year}_${month}_${day}`;
        const isLoaded = _.values(getState().calendar.dayList).includes(dayKey);
        const infoTree = getState().calendar.infoTree;

        const programMatch =
            infoTree.programId === programId || infoTree.team.id === programId;

        DesignerState.setInfo(ProgramTypes.TYPES.TEAM, this.props.match.params);
        if (isLoaded && programMatch) {
            AppState.stopLoading();
            return;
        }

        CalendarState.loadTeamCalendar(programId, year, month, day);
    }

    render() {
        Console.render('TeamDesignerView');
        return <DesignerBase />;
    }
}
